module.exports = __webpack_public_path__ + "media/images/public-step3-1ed890b5cef55adfd0b34bb5d507c44e.png";